@<template>
  <div>
    <div class="examination">
      <div class="function-box">
        <div class="doT-one"></div>
        <div class="doT-two"></div>
        <div class="training">
          <p>{{$t('i.login.functionalClassification')}}</p>
        </div>
      </div>
      <div class="category-box">
        <div class="category1" @click="getIntoModular('1')">
          <p class="category1-p0">
            <a href="javascript:void(0)">{{$t('i.login.rules')}}</a>
          </p>
            <p class="category1-p1" style="color: #b594b5;"></p>
            <p class="category1-p2">
            </p>
          <img src="../../../../static/indexImg/Department.png" :alt="$t('i.login.rules')">
        </div>

        <div class="category2" @click="getIntoModular('2')">
          <p class="category2-p0">
            <a href="javascript:void(0)" >{{$t('i.login.research')}}</a>
          </p>
          <p class="category2-p1" style="color: #99c9e7;"></p>
          <p class="category2-p2"> </p>
          <img src="../../../../static/indexImg/Study.png" :alt="$t('i.login.research')">
        </div>

        <div class="category3" @click="getIntoModular('3')">
          <p class="category3-p0">
            <a href="javascript:void(0)" >{{$t('i.login.examination')}}</a>
          </p>
            <p class="category3-p1" style="color: #9bba82"></p>
            <p class="category3-p2"></p>
          <img src="../../../../static/indexImg/Examination.png" alt="考 试">
        </div>

        <div class="category4" @click="getIntoModular('4')">
          <p class="category4-p0">
            <a href="javascript:void(0)" >{{$t('i.login.testResume')}}</a>
          </p>
            <p class="category4-p1" style="color: #dc9b9b;"></p>
            <p class="category4-p2"></p>
          <img src="../../../../static/indexImg/Betold.png" alt="受讲及考试履历">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import LatestNews from "../../../common/components/LatestNews";
  export default {
    components: {LatestNews},
    data(){
      return{
        LatestNews:[]
      }
    },
    name: "majorfunction",
    methods: {
      getIntoModular(type){
          const user = localStorage.getItem("userInfo");
          if(!user){
            this.$Message.warning({content: this.$t('i.login.LoginMsg'),duration: 5});
            this.$router.push({name:'login'})
            return false;
          }
          if(type == '1'){
            const domain = localStorage.getItem("domain");
            if(domain == 6) {
              this.$Message.warning({content: this.$t('i.login.noAuthEntry'),duration: 5});
              return
            }
            let id = 'SSLY000001'
            if (domain == '2'){
                id = 'SSLY000002'
            } else if (domain == '3'){
                id = 'SSLY000003'
            } else if (domain == '4') {
                id = 'SSLY000004'
            } else if (domain == '5') {
              id = 'SSLY000005'
            }
            // level是用来判断当前是第几层的
            this.$router.push({name:'studyAndStudy',query : {type:'2',name: this.$t('i.login.rules'),id: id, color: '#996699', level: 1}})
          }else if (type == '2'){
            this.$router.push({name:'studyModel',query : {type:'newPerson',itemName: '新人研修', pname: '研修' }})
            // this.$router.push({name:'studyModule',query : {type:'1',name: this.$t('i.login.research'),id:'studyModule', color: '#54abdb'}})
          } else if (type == '3'){
            this.$router.push({name:'examination'})
          } else{
            this.$router.push({name:'resume'})
        }
      }
    },
    mounted () {}
  }
</script>

<style scoped>
  .examination{
    width: 860px;
    height: 443px;
    float: left;
    /*margin-top: 120px;*/
  }
  .examination a{
    color: #fff;
  }
  .function-box{
    width: 860px;
    height: 40px;
  }
  .doT-one{
    width: 10px;
    height: 10px;
    margin-left: 102px;
    background-color: #e50020;
    display: inline-block;
    float: left;
  }
  .doT-two{
    width: 10px;
    height: 10px;
    background-color: #a8a8a9;
    margin-top: 20px;
    margin-left: -10px;
    float: left;
  }
  .training{
    width: 200px;
    height: 30px;
    font-size: 30px;
    margin-left: 128px;
    padding-top: 1px;
  }
  .training p{
    margin-top: -8px;
  }
  .category-box{
    width: 860px;
    height: 402px;
    margin-top: 20px;
  }

  .category1,
  .category2,
  .category3,
  .category4{
    width: 330px;
    height: 190px;
    border-radius: 10px;
    float: left;
    position: relative;
  }
  .category1{
    background-color: #996699;
    margin-left: 130px;
  }
  .category2{
    margin-left: 50px;
    background-color: #54abdb;
  }
  .category3{
    margin-top: 22px;
    margin-left: 130px;
    background-color: #669934;
  }
  .category4{
    margin: 22px 0 0 50px;
    background-color: #cd6666;
  }
  .category1-p0,
  .category2-p0,
  .category3-p0,
  .category4-p0
  {
    font-size: 35px;
    line-height: 200px;
    text-align: center;
  }
  .category1-p1,
  .category2-p1,
  .category3-p1,
  .category4-p1
  {
    font-family:'SimSun';
    font-size: 80px;
    position: absolute;
    top: 95px;
    left: 2px;
  }
  .category1-p2{
    font-size: 21px;
    color: #b594b5;
    font-weight: lighter;
    position: absolute;
    left: 45px;
    top: 125px;
  }
  .category2-p2{
    font-size: 36px;
    color: #99c9e7;
    font-weight: lighter;
    position: absolute;
    top: 135px;
    left: 50px;
  }
  .category3-p2{
    font-size: 30px;
    color: #9bba82;
    position: absolute;
    top: 140px;
    left: 50px;
    font-weight: lighter;
  }
  .category4-p2{
    font-size: 21px;
    position: absolute;
    top: 125px;
    left: 50px;
    color: #dc9b9b;
    font-weight: lighter;
  }
  .category1 img {
    width: 77px;
    height: 83px;
    position: absolute;
    top: 0px;
    left: 240px;
  }
  .category2 img {
    width: 89px;
    height: 77px;
    position: absolute;
    top: 3px;
    left: 232px;
  }
  .category3 img{
    width: 68px;
    height: 79px;
    position: absolute;
    top: 5px;
    left: 250px;
  }
  .category4 img{
     width: 66px;
     height: 80px;
     position: absolute;
     top: 2px;
     left: 252px;
   }
</style>



// WEBPACK FOOTER //
// src/pages/home/components/majorfunction.vue